<template>
  <div class="body">
    <pageTitle id="dom1" title="品种追踪列表"></pageTitle>
    <div id="dom2" class="head bb p20 flex fw_w">
      <div>
        <div>追踪ID</div>
        <div>
          <el-input
            style="width: 140px"
            clearable
            :size="size"
            v-model="track_id"
            placeholder="请输入追踪ID"
          ></el-input>
        </div>
      </div>
      <div>
        <div>品种</div>
        <div>
          <el-select
            style="width: 140px"
            v-model="category_id"
            class="m-2"
            placeholder="请选择品种"
            :size="size"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="(item, index) in categoryList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
      </div>
      <div>
        <div>高级投顾</div>
        <div>
          <el-select
            style="width: 140px"
            v-model="teacher_name"
            class="m-2"
            placeholder="请选择高级投顾"
            :size="size"
          >
            <el-option label="全部" value="" />
            <el-option
              v-for="(item, index) in teacherList"
              :key="index"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </div>
      </div>
      <div>
        <div>发布时间</div>
        <div>
          <el-date-picker
            style="width: 180px"
            v-model="time_range"
            type="date"
            placeholder="请选择发布时间"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            :size="size"
          />
        </div>
      </div>
      <!-- <div>
          <div>是否平仓</div>
          <div>
            <el-select v-model="type" class="m-2" placeholder="" size="large">
              <el-option label="全部" :value="0" />
              <el-option label="未平仓" :value="1" />
              <el-option label="已平仓" :value="2" />
            </el-select>
          </div>
        </div>
        <div>
          <div>状态</div>
          <div>
            <el-select v-model="status" class="m-2" placeholder="" size="large">
              <el-option label="全部" :value="0" />
              <el-option label="止盈平仓" :value="1" />
              <el-option label="止损平仓" :value="2" />
            </el-select>
          </div>
        </div> -->
      <div>
        <el-button @click="getTrackList(1)" type="primary">搜 索</el-button>
      </div>
    </div>
    <div
      :style="{ height: `calc(100% - (${dom1 + 'px'} + ${dom2 + 'px'}))` }"
      v-loading="listLoading"
    >
      <div
        class="bb pl20 pr20"
        :style="{ height: `calc(100% - (${dom3 + 'px'}))` }"
      >
        <el-table :data="trackList" height="100%" style="width: 100%">
          <el-table-column
            width="80"
            align="center"
            prop="track_id"
            label="追踪ID"
          />
          <el-table-column width="150" align="center" label="图片">
            <template #default="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.image"
                :preview-src-list="[scope.row.image]"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column width="300" align="center" label="标题">
            <template #default="scope">
              {{ scope.row.title }}
            </template>
          </el-table-column>
          <el-table-column width="300" align="center" label="品种合约">
            <template #default="scope">
              {{ scope.row.category.name }}
            </template>
          </el-table-column>
          <el-table-column width="200" align="left" label="品种追踪">
            <template #default="scope">
              {{ scope.row.zhuizong }}
            </template>
          </el-table-column>
          <el-table-column width="200" align="left" label="区间">
            <template #default="scope">
              {{ scope.row.qujian_type }}
            </template>
          </el-table-column>
          <el-table-column width="200" align="left" label="区间数据">
            <template #default="scope">
              {{ scope.row.qujian1 }}~{{ scope.row.qujian2 }}
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            align="center"
            prop="teacher_name"
            label="高级投顾"
          >
          </el-table-column>
          <el-table-column
            width="170"
            align="center"
            prop="createtime_text"
            label="发布时间"
          />
        </el-table>
      </div>
      <div id="dom3" class="bb p20">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          v-model:page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
          :page-sizes="[15, 50, 100, 200]"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import pageTitle from "@/components/pageTitle.vue";
import { addSiteStatistics } from "@/utils/common";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      track_id: null,
      teacher_name: "",
      time_range: "", // 发布时间范围
      type: "",
      status: "",
      teacherList: [], //研究员列表
      page: 1,
      pageSize: 15,
      trackList: [],
      listLoading: false,
      categoryList: [],
      category_id: null,

      size: "default",
      dom1: 0,
      dom2: 0,
      dom3: 0,
    };
  },
  mounted() {
    window.onmessageSocket = this.onmessage;
    setTimeout(() => {
      this.initTableHeight();
    }, 1000);

    this.getBaseInfo1();
    this.getBaseInfo2();
    this.getTrackList(1);
    addSiteStatistics({ type: 396 });
  },
  methods: {
    onmessage(e) {},
    initTableHeight() {
      this.dom1 = document.getElementById("dom1").offsetHeight;
      this.dom2 = document.getElementById("dom2").offsetHeight;
      this.dom3 = document.getElementById("dom3").offsetHeight;
      console.log("this.dom3", this.dom3);
    },
    // 获取基础信息
    async getBaseInfo2() {
      const res = await request.post("/teacher/bbas/getBaseInfo");
      this.categoryList = res.data.categoryList;
    },
    // 获取基础信息
    async getBaseInfo1() {
      const res = await request.post("/teacher/technology_case/getBaseInfo");
      this.teacherList = res.data.teacherList;
    },
    // 获取追踪信息列表
    async getTrackList(page) {
      this.listLoading = true;
      // var time_range0 = this.time_range ? [...this.time_range] : [];
      // if (time_range0.length) {
      //   time_range0[0] = time_range0[0] / 1000;
      //   time_range0[1] = time_range0[1] / 1000;
      // }
      const res = await request.post("/teacher/technology_case/trackList", {
        page,
        track_id: this.track_id,
        category_id: this.category_id,
        teacher_name: this.teacher_name,
        time_range: this.time_range,
        limit: this.pageSize,
      });
      this.page = page;
      this.total = res.data.total;
      this.trackList = res.data.data;
      this.listLoading = false;
    },
    handleCurrentChange(val) {
      this.getTrackList(val);
      console.log(`当前页: ${val}`);
    },
    handleSizeChange(val) {
      this.getTrackList(1);
    },
  },
};
</script>

<style scoped>
.body {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.el-table ::v-deep th.el-table__cell,
.el-table ::v-deep td.el-table__cell {
  position: static;
}

.head {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 15px;
}

.head > div {
  display: flex;
  align-items: center;
}

.head > div > div:first-child {
  margin-right: 10px;
  font-size: 14px;
  /* margin-bottom: 10px; */
}

.w200 {
  width: 200px;
}

.teacher_remark {
  max-width: 300px;
  display: inherit !important;
}
</style>
